import { FC, useState } from 'react';

import { Box, Modal, ModalContent, ModalOverlay } from '@bonusly/design-system';

import { AwardModalContent } from './AwardModalContent';
import { AwardModalState } from './AwardModalState';
import { useAwardModal } from './hooks/useAwardModal';

export const GiveAwardModal: FC = () => {
	const [isSubmitting, setIsSubmitting] = useState(false);
	const modal = useAwardModal();

	return (
		<AwardModalState setIsSubmitting={setIsSubmitting} {...modal}>
			<Modal scrollBehavior="inside" size="2xl" closeOnOverlayClick={!isSubmitting} {...modal}>
				<ModalOverlay />
				<ModalContent data-testid="give-award-modal">
					<AwardModalContent />
					{isSubmitting && <Box bgColor="whiteAlpha.700" rounded="md" cursor="not-allowed" inset={0} position="absolute" />}
				</ModalContent>
			</Modal>
		</AwardModalState>
	);
};
